import { createSelector } from 'reselect';

const selectLMSCollections = (state: any) => state.lmsCollections;


export const selectLMSCollectionsCurrentItem = createSelector([selectLMSCollections], (lmsCollections) => lmsCollections.current);

export const selectLMSCollectionsListItems = createSelector([selectLMSCollections], (lmsCollections) => lmsCollections.list);

export const selectLMSCollectionsItemById = (itemId: any) =>
    createSelector(selectLMSCollectionsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectLMSCollectionsQueryItems = createSelector([selectLMSCollections], (lmsCollections) => lmsCollections.query);

export const selectLMSCollectionsCreatedItem = createSelector([selectLMSCollections], (lmsCollections) => lmsCollections.create);

export const selectLMSCollectionsUpdatedItem = createSelector([selectLMSCollections], (lmsCollections) => lmsCollections.update);

export const selectLMSCollectionsReadItem = createSelector([selectLMSCollections], (lmsCollections) => lmsCollections.read);

export const selectLMSCollectionsDeletedItem = createSelector([selectLMSCollections], (lmsCollections) => lmsCollections.delete);

export const selectLMSCollectionsSearchedItems = createSelector([selectLMSCollections], (lmsCollections) => lmsCollections.search);

export const selectLMSCollectionsItemsCount = createSelector([selectLMSCollections], (lmsCollections) => lmsCollections.count);

export const selectLMSCollectionsItemsFilter = createSelector([selectLMSCollections], (lmsCollections) => lmsCollections.filter);